
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","overflow":"visible","preserveAspectRatio":"none","version":"1.2","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#030404","d":"M9.5 24.68v-8.84l15.64.04v8.8H9.5zm3.4-13.98v.92a.75.75 0 001.5 0v-.92h5.79v.92a.75.75 0 001.5 0v-.92h3.45v3.67L9.5 14.34V10.7h3.4zm12.24-1.5H21.7V7.75a.75.75 0 10-1.5 0v1.46h-5.8V7.75a.75.75 0 00-1.5 0v1.46H9.5C8.67 9.2 8 9.88 8 10.7v13.97c0 .83.67 1.5 1.5 1.5h15.64c.83 0 1.5-.67 1.5-1.5V10.7c0-.83-.67-1.5-1.5-1.5z","vector-effect":"non-scaling-stroke","fill-rule":"evenodd"}})])
          )
        }
      }
    